import * as actionTypes from "./constants";

import { sortData } from "../../screens/Config/utils";
const initialState = {
  processing: false,
  error: false,
  runnerList: [],
  runnerdtlList1: [{ value: "", name: "All" }],
  runnerdtlList: [],
  runnersubsrptnList: [],
  loading: true,
  subsrptnLogList: [],
};

export default function MySubscriptionReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_MYPLANS_SUCCESS_ACTION:
      return {
        ...state,
        processing: false,
        subplansList: action.payload.rows,
        subplansCount: action.payload.count,
      };
    case actionTypes.FETCH_MYPLANS_ACTION:
      return {
        ...state,
        processing: true,
      };
    case actionTypes.FETCH_SUBSCRIPTION_ACTION:
      return {
        ...state,
        processing: true,
      };
    case actionTypes.FETCH_SUBSCRIPTION_SUCCESS_ACTION:
      return {
        ...state,
        loading: false,
        processing: false,
        subscriptionList: action.payload.rows,
        subscriptionCount: action.payload.count,
      };
    case actionTypes.FETCH_SUB_PAYMENTMODE_SUCCESS_ACTION:
      return {
        ...state,
        paymentmodeList: action.payload.rows,
      };
    case actionTypes.FETCH_RUNNER_BYID_SUCCESS_ACTION:
      return {
        ...state,
        runnerList: action.payload,
      };

    case actionTypes.FETCH_RUNNER_USER_SUCCESS_ACTION:
      let tempRunnerDtlListData = sortData(action.runnerdtlList);
      return {
        ...state,
        runnerdtlTypeList: action.payload.rows,
        runnerdtlList: [...state.runnerdtlList1, ...tempRunnerDtlListData],
      };
    case actionTypes.FETCH_SUBSCRIPTION_LOG_SUCCESS_ACTION:
      return {
        ...state,
        subsrptnLogList: action.payload.rows,
        subsrptnLogCount: action.payload.count,
      };
    case actionTypes.FETCH_TOTALSUBSCRPTN_ACTION:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.FETCH_TOTALSUBSCRPTN_SUCCESS_ACTION:
      return {
        ...state,
        loading: false,
        runnersubsrptnList: action.payload.rows,
      };
    case actionTypes.SUBSCRIBE_LOG_SUCCESS_ACTION:
      return {
        ...state,
        subLogList: action.payload.rows,
        subLogCount: action.payload.count,
      };
    case actionTypes.FETCH_SUB_CARGOSIZE_SUCCESS_ACTION:
      return {
        ...state,
        subCargoList: action.payload.rows,
      };

    case actionTypes.FETCH_HISTORYSUBSCRIPTION_SUCCESS_ACTION:
      return {
        ...state,
        processing: false,
        subscriptionHistoryList: action.payload.rows,
        subscriptionHistoryCount: action.payload.count,
      };
    case actionTypes.FETCH_HISTORYSUBSCRIPTION_ACTION:
      return {
        ...state,
        processing: true,
      };

    case actionTypes.CLEAR_SUBSCRIPTIONLOG_ACTION:
      return {
        ...state,
        subsrptnLogList: [],
      };

    default:
      return {
        ...state,
      };
  }
}
